import { HOOK_RESULT__notifier } from '@/hooks/HOOK__notifier';
import { cn } from '@/utils/utils_client';

interface Props {
  notifier: HOOK_RESULT__notifier;
  className?: string;
}

function NotifierBorder({ notifier, className }: Props) {
  return (
    <div
      className={cn('absolute inset-0.5 rounded-sm pointer-events-none', notifier.is_blinking && 'animate-blink-notify', className)}
      style={{ boxShadow: `0 0 0 2px ${notifier.is_blinking ? `var(--user-color-${notifier.color_index})` : 'transparent'}` }}
    />
  );
}

export default NotifierBorder;
